import React, { useState, Fragment } from "react";
import Input from "../common/input";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import _ from "lodash";
import { addRoom, editRoom } from "../../store/rooms";
import withTooltip from "../hoc/withTooltip";
import axios from "axios";
import { register } from "../../services/authService";
import { addUser } from "../../store/users";
import { CheckBox } from "devextreme-react/check-box";

export default function Register(props) {
  // const store = configureStore();

  // const customers = useSelector((state) => state.entities.customers.list);

  const [data, setData] = useState({
    name: "",
    userName: "",
    email: "",
    password: "",

    // password_confirmation: "",
  });
  const [isAdmin, setAdmin] = useState(false);
  const schema = {
    name: Joi.string()
      .required()
      .max(50)
      .label("Full Name")
      .error(() => {
        return {
          message: "Enter Your Name",
        };
      }),
    email: Joi.string()
      .email({ minDomainSegments: 2, tlds: { allow: false } })
      .error(() => {
        return {
          message: "Enter Your email",
        };
      }),
    userName: Joi.string()
      .required()
      .max(50)
      .label("UserName")
      .error(() => {
        return {
          message: "Enter correct username",
        };
      }),
    password: Joi.string()
      //   .pattern(new RegExp("^[a-zA-Z0-9]{3,30}$"))
      .required()
      .label("Password"),
    password_confirmation: Joi.any()
      .equal(Joi.ref("password"))
      .required()
      .label("Confirm password")
      .error(() => {
        return {
          message: "Password is not match",
        };
      }),
  };
  const [errors, setErrors] = useState({});

  const validate = () => {
    const result = Joi.validate(data, schema, {
      abortEarly: false,
    });

    if (!result.error) return null;
    let errors = {};
    toast.error("error");
    for (let item of result.error.details) {
      errors[item.path[0]] = item.message;
    }
    setErrors(errors);
    return errors;
  };
  //   const formErrors = validate();

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const inputSchema = { [name]: schema[name] };
    const { error } = Joi.validate(obj, inputSchema);
    if (!error) return null;
    return error.details[0].message;
  };

  const handleChange = (input) => {
    const inputData = { ...data };
    const inputErrors = { ...errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) inputErrors[input.name] = errorMessage;
    else delete inputErrors[input.name];
    inputData[input.name] = input.value;
    setData(inputData);
    setErrors(inputErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    setErrors(errors || {});

    if (errors) {
      return;
    }
    try {
      // console.log(data);
      register(data, isAdmin);
      props.onClose();
    } catch (ex) {
      toast.error(ex.response.data.message);
      if (ex.response && ex.response.status === 500) {
        // const err = { ...errors };
        // err.password =
        //   "Password must include uppercase,lowercase symbol and numbers";
        // setErrors(err);
      } else {
      }
    }

    // store.dispatch(addCustomer(data));

    // this.doSubmit();
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="card-body">
        <Input
          name="name"
          label="نام و فامیل"
          onChange={handleChange}
          value={data["name"]}
          errors={errors["name"]}
          req={true}
        ></Input>
        <Input
          name="userName"
          label="نام کاربری"
          onChange={handleChange}
          value={data["userName"]}
          errors={errors["userName"]}
          req={true}
        ></Input>
        {/* <label>Color</label> */}
        <Input
          name="password"
          label="رمز عبور"
          onChange={handleChange}
          value={data["password"]}
          errors={errors["password"]}
          type="password"
          req={true}
        ></Input>
        <Input
          name="password_confirmation"
          label="تکرار رمز عبور"
          onChange={handleChange}
          value={data["password_confirmation"]}
          errors={errors["password_confirmation"]}
          type="password"
          req={true}
        ></Input>

        <Input
          name="email"
          label="ایمیل"
          onChange={handleChange}
          value={data["email"]}
          errors={errors["email"]}
          req={true}
        ></Input>
        <div className="alert alert-warning">
          <CheckBox
            defaultValue={false}
            onValueChanged={(e) => {
              setAdmin(e.value);
              // setShowAllArrivals(e.value);
            }}
            text="ثبت به عنوان کاربر ارشد"
          />
        </div>
      </div>
      <div className="d-grid gap-2 bd-highlight ">
        <button type="submit" className="btn btn-primary">
          ثبت کاربر
        </button>
        <button
          type="button"
          className="btn btn-light "
          onClick={() => props.onClose()}
          // disabled={Boolean(validate())}
        >
          انصراف
        </button>
      </div>
    </form>
  );
}
